export const INVALID_EMAIL_MESSAGE = 'Please enter valid email address';
export const EMAIL_REQUIRED = 'Please enter your email address';
export const PASSWORD_REQUIRED = 'Please enter your password';
export const SOMETHING_WENT_WRONG = 'Something went wrong';
export const SESSION_EXPIRED_MESSAGE =
  'Your session has expired. Please log in again.';
export const NETWORK_ERROR_MESSAGE =
  'Unable to reach the server. Please check your connection and try again.';
export const LOGIN_FAILED_MESSAGE = 'We could not sign you in. Please try again.';
